"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_ALIGN = exports.TRANSLATION = exports.TEXT_TYPE = exports.TEXT_DIRECTION = exports.TEXT_ALIGN = exports.DISPLAY = exports.DEFAULT_TAG = exports.ARR_TEXT_TYPE = void 0;
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  },
  titleNormal: {
    type: 'titleNormal',
    size: 'titleNormal',
    lineHeight: 'titleSmall'
  },
  medium: {
    type: 'medium',
    size: 'medium',
    lineHeight: 'small'
  },
  titleSmall: {
    type: 'titleSmall',
    size: 'titleSmall',
    lineHeight: 'titleSmall'
  },
  titleLarge: {
    type: 'titleLarge',
    size: 'titleSmall',
    lineHeight: 'XXLarge'
  },
  textSmall: {
    type: 'small',
    size: 'small',
    lineHeight: 'small'
  },
  textNormal: {
    type: 'textNormal',
    size: 'small',
    lineHeight: 'semiLarge'
  },
  textLarge: {
    type: 'textLarge',
    size: 'normal',
    lineHeight: 'XLarge'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var TEXT_DIRECTION = ['ltr', 'rtl'];
exports.TEXT_DIRECTION = TEXT_DIRECTION;
var TEXT_ALIGN = ['left', 'center', 'right', 'justify'];
exports.TEXT_ALIGN = TEXT_ALIGN;
var DISPLAY = {
  block: 'block',
  inlineFlex: 'inline-flex',
  inline: 'inline'
};
exports.DISPLAY = DISPLAY;
var ARR_TEXT_TYPE = Object.keys(TEXT_TYPE);
exports.ARR_TEXT_TYPE = ARR_TEXT_TYPE;
var VERTICAL_ALIGN = {
  flexStart: 'flex-start',
  flexEnd: 'flex-end',
  center: 'center'
};
exports.VERTICAL_ALIGN = VERTICAL_ALIGN;
var TRANSLATION = {
  more: 'More',
  less: 'Less'
};
exports.TRANSLATION = TRANSLATION;
var DEFAULT_TAG = 'p';
exports.DEFAULT_TAG = DEFAULT_TAG;